module.exports = __webpack_public_path__ + "static/dgraph-speakers-f0d689d3ada46751a0727744ff577831.png";